import { useState, useCallback } from 'react';
import {
  Button,
  Form,
  Input,
} from '@skyline-platform/alchemy';
import * as is from 'is';
import { MAX_NUM_ROWS } from '@utils/client-upload/csv/hook';
import { Message } from '@components/Misc';

export const FileInputForm = (properties) => {
  const {
    handleCancel,
    handleUpload,
    uploadButtonState,
    handleInputOnChange,
    notification,
    showDelete,
    handleDownload,
  } = properties ?? {};
  const [className, setClassName] = useState('');
  const handleChange = useCallback(
    (event) => {
      if (is.function(handleInputOnChange)) {
        handleInputOnChange(event);
      }
      if (!(event.target.files instanceof FileList)) {
        setClassName('');
        return;
      }
      setClassName('filelist-selected');
    }
  );
  return (
    <Form
      formTitle='Bulk Import'
      footer={[
        <>
          <Button
            label='Download Excel template'
            state='default'
            type='text'
            iconLeft='fas fa-file-csv'
            handleClick={handleDownload}
            test-id='download-template-button'
          />
          <div>
            <Button
              label='Cancel'
              state='default'
              type='outlined'
              handleClick={handleCancel}
              test-id='cancel-upload-button'
            />
            <Button
              label='Upload File'
              state={uploadButtonState}
              type='filled'
              handleClick={handleUpload}
              showDelete={showDelete}
              test-id='upload-file-button'
            />
          </div>
        </>,
      ]}
    >
      <p>Upload a CSV file. Max limit - {MAX_NUM_ROWS} streams.</p>
      <div className='bulk-import-browser'>
        <Input
          placeholder='No file is selected'
          type='file'
          id='bulk-import-browse-file'
          inputLabel='Browse Files'
          onChange={handleChange}
          clearTextButton={true}
          clearTextIcon='fa-solid fa-trash-can'
          className={className}
          errorMessage={notification.type === 'error' ? notification.message : false}
        />
      </div>
      {notification?.message && <Message
        message={notification.message}
        type={notification.type}
        centering={notification.centering ?? 'left'}
      />}
    </Form>
  );
};
